import { useCallback } from 'react'
import {
  useUpdateDocumentVersionSession,
  useUpdateDocumentVersionSessionEvent,
} from '@/services/queries/document_sessions'
import { useTechnicianPageStore } from './useTechnicianPageStore'

export const useEndSession = () => {
  const { mutateAsync: updateSession, isPending } =
    useUpdateDocumentVersionSession()
  const { mutateAsync: updateEvent } = useUpdateDocumentVersionSessionEvent()

  const endSession = useCallback(
    async (options?: { completeLastEvent?: boolean }) => {
      const completeLastEvent = options?.completeLastEvent ?? true
      const {
        currentSessionId: activeSessionId,
        currentTechnician: activeTechnician,
        lastSessionEventId: activeLastSessionEventId,
      } = useTechnicianPageStore.getState()

      if (activeSessionId && activeTechnician) {
        if (activeLastSessionEventId && completeLastEvent) {
          await updateEvent({
            documentVersionSessionEventId: activeLastSessionEventId,
            completedTimestamp: new Date().toISOString(),
          })
        }

        await updateSession({
          documentVersionSessionId: activeSessionId,
          completedTimestamp: new Date().toISOString(),
          username: activeTechnician,
        })
      }
    },
    [updateEvent, updateSession],
  )

  return {
    endSession,
    isPending,
  }
}
